import axios from 'axios'
import { Dialog } from 'vant';

function showNocifaction() {
  axios.get('http://yc.novaecs.com/api/yc2/yc/commonNotifaction').then(x=>{
  let data = x.data
  if (data.status === 0) {
    let msg = data.msg
    Dialog({ message: msg });
  }
})
}


export {
  showNocifaction
}


// WEBPACK FOOTER //
// ./src/utils/commonNotifaction.js